import * as yup from "yup";


const ContactFormSchema = yup.object().shape({
    name: yup
        .string()
        .required('Please Enter Name'),
    email: yup
        .string()
        .email("Please enter a valid email!")
        .required("Please Enter Email"),
    company: yup
        .string(), // Optional field
    phone: yup
        .string()
        .matches(/^[0-9]+$/, "Phone number can only contain digits")
        .transform((value) => value ? value.replace(/[^0-9]/g, '') : '')
        .length(10, 'Phone must be exactly 10 digits'), // Optional but validated if provided
    message: yup
        .string()
        .min(10, "Message must be at least 10 characters")
        .required('Please Enter Message'),
});


export default ContactFormSchema;


